import { apileadsVirgilio } from '../enviroment/apileadsVirgilio'

const inicioService = async (body) => {
  const response = await apileadsVirgilio.post('inicio', body)
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const almacenadoService = async (id) => {
  const response = await apileadsVirgilio.get(
    `procedimientos_almacenado?id=${id}`,
  )
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const capaControladorService = async (id, type) => {
  const response = await apileadsVirgilio.get(
    `java_capas?id=${id}&tipo=${type}`,
  )
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const pruebasService = async (id, type) => {
  const response = await apileadsVirgilio.get(`java_pu?id=${id}&tipo=${type}`)
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const postmanService = async (id) => {
  const response = await apileadsVirgilio.get(`postman?id=${id}`)
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const frontService = async (id, type) => {
  const response = await apileadsVirgilio.get(`front?id=${id}&tipo=${type}`)
  try {
    if (response.status === 200) {
      return response
    }
  } catch (error) {
    console.log('Error get List ')
  }
}

const ensamblarFront = async (id) => {
    const response = await apileadsVirgilio.get(`ensamblar_front?id=${id}`)
    try {
      if (response.status === 200) {
        return response
      }
    } catch (error) {
      console.log('Error get List ')
    }
  }


const ensamblarBack = async (id) => {
    const response = await apileadsVirgilio.get(`ensamblar_backend?id=${id}`)
    try {
      if (response.status === 200) {
        return response
      }
    } catch (error) {
      console.log('Error get List ')
    }
  }


export {
  inicioService,
  almacenadoService,
  capaControladorService,
  pruebasService,
  postmanService,
  frontService,
  ensamblarFront,
  ensamblarBack
}
